export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/add-icon.svg?c023262da8c2da53a0e34765984bfd38";